import React from 'react'
import { Redirect, Route } from 'react-router-dom'
import { SIGNIN_URL } from 'constants/urls'

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
	<Route
		{...rest}
		render={props =>
			auth ? <Component {...props} /> : <Redirect to={SIGNIN_URL} />
		}
	/>
)
export default PrivateRoute
